// src/redux/reducers/apiReducer.js
import { API_SUCCESS, API_FAILURE} from '../Redux/apiActions'

const initialState = {
  data: {},
  error: {}
};

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case API_SUCCESS:
      return {
        ...state,
        data: { ...state.data, [action.payload.key]: action.payload.data }
      };
    case API_FAILURE:
      return {
        ...state,
        error: { ...state.error, [action.payload.key]: action.payload.error }
      };
    default:
      return state;
  }
};

export default apiReducer;
